import React from "react";
import { Outlet } from "react-router-dom";

const AuthViews = () => {
  return (
    <div className="">
      <Outlet />
    </div>
  );
};

export default AuthViews;
